import Http from '@/api/http.js'

export default {

  index() {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/remote_accounts`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/remote_accounts`)
  },

  create(account){
    return Http.post(`/remote_accounts`, {account: {...account}})
  },

  update(account){
    return Http.put(`/remote_accounts/${account.id}`, {
      account: {...account},
    });
  },

  show(id) {
    return Http.get(`/remote_accounts/${id}`);
  },

  delete(id){
    return Http.delete(`/remote_accounts/${id}`)
  }

}
